import React from 'react';

export const DepDateContext = React.createContext();

export default DepDateContext;